<template>
  <input
    class="dpd-input"
    :value="value"
    :placeholder="placeholder"
    @click="$emit('click', $event)"
    @input="emitInput"
    @paste="emitPaste"
    @focus="$emit('focus', $event)"
    @blur="$emit('blur', $event)"
    @mousedown="$emit('mousedown', $event)"
    @keydown="$emit('keydown', $event)"
  />
</template>

<script>
import { tryParse } from '../../../../libraries/common';
import { getCriteriaCode } from '../../../../libraries/criteria';
export default {
  noExport: true,
  props: ['value', 'placeholder'],
  methods: {
    emitInput(event) {
      this.$emit('input', event.target.value);
    },
    emitPaste(event) {
      event.preventDefault();
      var text = event.clipboardData.getData('text/plain');
      var pasteItem = tryParse(localStorage.getItem('clipboard'));
      var pasteItemText = pasteItem && (getCriteriaCode(pasteItem.label) || pasteItem.label);
      this.$emit('paste', pasteItem?.type !== 'bad-code' && pasteItemText === text ? pasteItem : text);
    },
  },
}
</script>

<style lang="scss" scoped>
input:focus-visible {
  outline: none;
}

.dpd-input {
  height: 47px;
}
</style>